export default __webpack_public_path__ + "static/media/regulatory--dual-path-bicycles-and-pedestrians--g3.4194fc44.png";